module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/babel-runtime/core-js/map.js
// module id = 711
// module chunks = 0